import React from 'react';
import ApexChart from 'react-apexcharts';
import { Box } from '@mui/material';

const ImpactChart = (props: { series: number[][], compare?: number[][], height?: number }) => {

  const markerSize = Math.max(2, 10 - Math.log2(Math.max(props.series.length, props.compare?.length ?? 0, 1)));

  const series = [
    {
      name: "Impact score",
      type: "scatter",
      data: props.compare ?? []
    },
    {
      name: "Impact score",
      type: "scatter",
      data: props.series
    }
  ];

  const options = {
    chart: {
      background: "transparent",
      toolbar: {
        show: false
      }
    },
    legend: {
      show: false
    },
    zoom: {
      enabled: false,
      allowMouseWheelZoom: false
    },
    selection: {
      enabled: false
    },
    xaxis: {
      title: { 
        text: 'Impact',
        style: {
          fontFamily: 'var(--header-font)',
          fontWeight: 500,
          fontSize: 12
        }
      },
      labels: {
        style: {
          fontFamily: 'var(--header-font)',
        },
        formatter: function (val: number) {
          const labels = {
            1: " ",
            2: "Low",
            3: "Medium",
            4: "Very high"
          };
          return labels[val] || val;
        }
      },
      axisBorder: {
        show: true,
        color: "var(--color-greyDark)"
      },
      tickAmount: 3,
      type: "numeric",
      decimalsInFloat: 2,
      min: 1,
      max: 4
    },
    yaxis: {
      title: { 
        text: 'Frequency',
        style: {
          fontFamily: 'var(--header-font)',
          fontWeight: 500,
          fontSize: 12
        } 
      },
      labels: {
        style: {
          fontFamily: 'var(--header-font)',
        },
        formatter: function (val: number) {
          const labels = {
            1: "Only once",
            2: "Less often",
            3: "Monthly",
            4: "Weekly",
            5: "Daily"
          };
          return labels[val] || val;
        }
      },
      axisBorder: {
        show: true,
        color: "var(--color-greyDark)"
      },
      type: "numeric",
      tickAmount: 4,
      decimalsInFloat: 2,
      min: 1,
      max: 5
    },
    grid: {
      yaxis: {
        lines: {
          show: false
        }
      }
    },
    markers: {
      size: [markerSize],
      colors: ["var(--color-greyDark)", "var(--color-purple)"]
    },
    tooltip: {
      enabled: false
    },
  };

  return <Box style={{ pointerEvents: 'none' }}>
            <ApexChart options={options} 
                        series={series} 
                        height={props.height ?? 350}
                        type="scatter" />
        </Box>
};

export default ImpactChart;